import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: white;
  padding: 24px;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
`;

const Title = styled.h2`
  margin-bottom: 16px;
  color: #374151;
`;

const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 16px;
`;

const RadioOption = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

const TextArea = styled.textarea`
  width: 100%;
  padding: 8px;
  border: 1px solid #E5E7EB;
  border-radius: 4px;
  margin-top: 8px;
  min-height: 100px;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
`;

const Button = styled.button`
  padding: 8px 16px;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  
  ${props => props.secondary ? `
    background-color: #fff;
    color: #374151;
    border: 1px solid #D1D5DB;
    
    &:hover {
      background-color: #F3F4F6;
    }
  ` : `
    background-color: #dc3545;
    color: white;
    border: none;
    
    &:hover {
      background-color: #c82333;
    }
  `}
`;

const reasons = [
    "Too expensive",
    "Not using the service enough",
    "Found a better alternative",
    "Missing features I need",
    "Technical issues",
    "Other"
];

const CancellationModal = ({ isOpen, onClose, onConfirm }) => {
    const [reason, setReason] = useState('');
    const [feedback, setFeedback] = useState('');

    const handleSubmit = () => {
        onConfirm({ reason, feedback });
    };

    if (!isOpen) return null;

    return (
        <ModalOverlay>
            <ModalContent>
                <Title>We&apos;re sorry to see you go</Title>
                <p>Please help us improve by letting us know why you&apos;re canceling:</p>

                <RadioGroup>
                    {reasons.map((r) => (
                        <RadioOption key={r}>
                            <input
                                type="radio"
                                name="cancelReason"
                                value={r}
                                checked={reason === r}
                                onChange={(e) => setReason(e.target.value)}
                            />
                            {r}
                        </RadioOption>
                    ))}
                </RadioGroup>

                <div>
                    <p>Additional feedback (optional):</p>
                    <TextArea
                        value={feedback}
                        onChange={(e) => setFeedback(e.target.value)}
                        placeholder="Please share any additional feedback that could help us improve..."
                    />
                </div>

                <ButtonGroup>
                    <Button secondary onClick={onClose}>
                        Keep Subscription
                    </Button>
                    <Button onClick={handleSubmit}>
                        Confirm Cancellation
                    </Button>
                </ButtonGroup>
            </ModalContent>
        </ModalOverlay>
    );
};

CancellationModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
};

export default CancellationModal; 


// WEBPACK FOOTER //
// ./src/components/Billsby/CancellationModal.jsx